// Episode data with YouTube links and auto-generated thumbnails
export const episodes = [
  // Season 3
  {
    id: "s3-ep-01",
    title: "S3 Ep 01 - Anil Kumar Kruthiventi",
    description: "BSc Chemistry → Chief Scientific Officer at Shapoorji Pallonji affiliate. A journey through pure science to industry leadership.",
    date: "2026-02-15",
    duration: "45:00",
    season: 3,
    episode: 1,
    guest: "Anil Kumar Kruthiventi",
    youtubeUrl: "https://www.youtube.com/watch?v=P-j1kyDOxMc",
    thumbnail: "https://img.youtube.com/vi/-5eIpRMuWp4/hqdefault.jpg",
    topics: ["Chemistry", "Pharma", "Leadership"]
  },
  {
    id: "s3-ep-02",
    title: "S3 Ep 02 - Dr. Sai Santosh Kumar Raavi",
    description: "SSSIHL Physics → Professor at IIT Hyderabad · FRSC. Exploring quantum physics and photonics research.",
    date: "2026-02-08",
    duration: "45:00",
    season: 3,
    episode: 2,
    guest: "Dr. Sai Santosh Kumar Raavi",
    youtubeUrl: "https://youtu.be/wOmCgyMhICE",
    thumbnail: "https://img.youtube.com/vi/wOmCgyMhICE/hqdefault.jpg",
    topics: ["Physics", "Quantum", "Research"]
  },
  {
    id: "s3-ep-03",
    title: "S3 Ep 03 - Prof. Rajesh Gopakumar",
    description: "JEE All India Rank 1 in 1987. He chose physics at IIT Kanpur. His work on string theory led to the Gopakumar-Vafa duality. Now Director of ICTS-TIFR, one of Asia's finest theoretical science institutes.",
    date: "2026-06-01",
    duration: "SHORT",
    isShort: true,
    season: 3,
    episode: 3,
    guest: "Prof. Rajesh Gopakumar",
    youtubeUrl: "https://youtube.com/shorts/ebo9_gNEjCA?feature=share",
    thumbnail: "https://img.youtube.com/vi/ebo9_gNEjCA/hqdefault.jpg",
    topics: ["Physics", "Research", "String Theory", "Academic"]
  },
  // Season 2
  {
    id: "s2-ep-67",
    title: "S2 Ep 67 - Vijay Sairam",
    description: "Insights on career growth and professional development.",
    date: "2025-12-15",
    duration: "45:00",
    season: 2,
    episode: 67,
    guest: "Vijay Sairam",
    youtubeUrl: "https://youtu.be/_1RXTVvT2lc",
    thumbnail: "https://img.youtube.com/vi/_1RXTVvT2lc/hqdefault.jpg",
    topics: ["Leadership", "Career"]
  },
  {
    id: "s2-ep-66",
    title: "S2 Ep 66 - Sujatha Sanjiv Nathan",
    description: "Leadership perspectives and professional journey.",
    date: "2025-12-08",
    duration: "45:00",
    season: 2,
    episode: 66,
    guest: "Sujatha Sanjiv Nathan",
    youtubeUrl: "https://youtu.be/k1M2iS4ZnMY",
    thumbnail: "https://img.youtube.com/vi/k1M2iS4ZnMY/hqdefault.jpg",
    topics: ["Leadership", "Growth"]
  },
  {
    id: "s2-ep-65",
    title: "S2 Ep 65 - Shubhayu Sengupta",
    description: "What AI can't replace in HR. The evolving role of human resources.",
    date: "2025-12-01",
    duration: "1:08:00",
    season: 2,
    episode: 65,
    guest: "Shubhayu Sengupta",
    youtubeUrl: "https://youtu.be/yam47ET6sX0",
    thumbnail: "https://img.youtube.com/vi/yam47ET6sX0/hqdefault.jpg",
    topics: ["AI", "HR", "Leadership"]
  },
  {
    id: "s2-ep-64",
    title: "S2 Ep 64 - Tanay, Pankaj, Nidhi & Shubhayu",
    description: "Panel discussion: How senior leaders make decisions at the speed of change.",
    date: "2025-11-24",
    duration: "55:37",
    season: 2,
    episode: 64,
    guest: "Tanay, Pankaj, Nidhi & Shubhayu",
    youtubeUrl: "https://youtu.be/RvdgxxPeRbU",
    thumbnail: "https://img.youtube.com/vi/RvdgxxPeRbU/hqdefault.jpg",
    topics: ["Leadership", "Panel", "Decision Making"]
  },
  {
    id: "s2-ep-63",
    title: "S2 Ep 63 - Pankaj, Shubhayu & Nitin",
    description: "Leadership insights and collaborative perspectives.",
    date: "2025-11-17",
    duration: "45:00",
    season: 2,
    episode: 63,
    guest: "Pankaj, Shubhayu & Nitin",
    youtubeUrl: "https://youtu.be/9KFS8EXw10s",
    thumbnail: "https://img.youtube.com/vi/9KFS8EXw10s/hqdefault.jpg",
    topics: ["Leadership", "Collaboration"]
  },
  {
    id: "s2-ep-62",
    title: "S2 Ep 62 - Pankaj, Nidhi & Lalit",
    description: "Multi-perspective discussion on modern leadership.",
    date: "2025-11-10",
    duration: "45:00",
    season: 2,
    episode: 62,
    guest: "Pankaj, Nidhi & Lalit",
    youtubeUrl: "https://youtu.be/a_897IRgFEY",
    thumbnail: "https://img.youtube.com/vi/a_897IRgFEY/hqdefault.jpg",
    topics: ["Leadership", "Discussion"]
  },
  {
    id: "s2-ep-61",
    title: "S2 Ep 61 - Pankaj Rai",
    description: "Deep dive into leadership and professional growth.",
    date: "2025-11-03",
    duration: "45:00",
    season: 2,
    episode: 61,
    guest: "Pankaj Rai",
    youtubeUrl: "https://youtu.be/ws_LgbJkaiQ",
    thumbnail: "https://img.youtube.com/vi/ws_LgbJkaiQ/hqdefault.jpg",
    topics: ["Leadership", "Growth"]
  },
  {
    id: "s2-ep-60",
    title: "S2 Ep 60 - Sunil Kumar",
    description: "Professional insights and career development strategies.",
    date: "2025-10-27",
    duration: "45:00",
    season: 2,
    episode: 60,
    guest: "Sunil Kumar",
    youtubeUrl: "https://youtu.be/V_40b6os2jo",
    thumbnail: "https://img.youtube.com/vi/V_40b6os2jo/hqdefault.jpg",
    topics: ["Career", "Development"]
  },
  {
    id: "s2-ep-59",
    title: "S2 Ep 59 - Sanjiv Agarwal",
    description: "Leadership perspectives and industry insights.",
    date: "2025-10-20",
    duration: "45:00",
    season: 2,
    episode: 59,
    guest: "Sanjiv Agarwal",
    youtubeUrl: "https://youtu.be/oHqR_gasmqs",
    thumbnail: "https://img.youtube.com/vi/oHqR_gasmqs/hqdefault.jpg",
    topics: ["Leadership", "Industry"]
  },
  {
    id: "s2-ep-58",
    title: "S2 Ep 58 - Azfar & Prasad",
    description: "Collaborative discussion on professional growth.",
    date: "2025-10-13",
    duration: "45:00",
    season: 2,
    episode: 58,
    guest: "Azfar & Prasad",
    youtubeUrl: "https://youtu.be/Uu0srovxeAk",
    thumbnail: "https://img.youtube.com/vi/Uu0srovxeAk/hqdefault.jpg",
    topics: ["Collaboration", "Growth"]
  },
  {
    id: "s2-ep-57",
    title: "S2 Ep 57 - JK & Swaraj",
    description: "Insights on innovation and leadership.",
    date: "2025-10-06",
    duration: "45:00",
    season: 2,
    episode: 57,
    guest: "JK & Swaraj",
    youtubeUrl: "https://youtu.be/mO7u9Q4Ee_g",
    thumbnail: "https://img.youtube.com/vi/mO7u9Q4Ee_g/hqdefault.jpg",
    topics: ["Innovation", "Leadership"]
  },
  {
    id: "s2-ep-56",
    title: "S2 Ep 56 - Atif & Pankaj",
    description: "Discussion on modern leadership challenges.",
    date: "2025-09-29",
    duration: "45:00",
    season: 2,
    episode: 56,
    guest: "Atif & Pankaj",
    youtubeUrl: "https://youtu.be/6X3o4eJ3c8s",
    thumbnail: "https://img.youtube.com/vi/6X3o4eJ3c8s/hqdefault.jpg",
    topics: ["Leadership", "Challenges"]
  },
  {
    id: "s2-ep-55",
    title: "S2 Ep 55 - Andrew Wallbridge",
    description: "Leader's Labyrinth: A leadership book that feels like a mirror.",
    date: "2025-09-22",
    duration: "27:38",
    season: 2,
    episode: 55,
    guest: "Andrew Wallbridge",
    youtubeUrl: "https://youtu.be/Vy8AH958MyQ",
    thumbnail: "https://img.youtube.com/vi/Vy8AH958MyQ/hqdefault.jpg",
    topics: ["Leadership", "Book Review"]
  },
  {
    id: "s2-ep-53",
    title: "S2 Ep 53 - Pradnya Kulkarni",
    description: "Insights on professional development and growth.",
    date: "2025-09-15",
    duration: "45:00",
    season: 2,
    episode: 53,
    guest: "Pradnya Kulkarni",
    youtubeUrl: "https://youtu.be/U4Ii1ha2Nqw",
    thumbnail: "https://img.youtube.com/vi/U4Ii1ha2Nqw/hqdefault.jpg",
    topics: ["Development", "Growth"]
  },
  {
    id: "s2-ep-52",
    title: "S2 Ep 52 - Anjali Dutta",
    description: "Human-first leadership in a tech-driven world.",
    date: "2025-09-08",
    duration: "47:31",
    season: 2,
    episode: 52,
    guest: "Anjali Dutta",
    youtubeUrl: "https://youtu.be/nErpU8WKzIM",
    thumbnail: "https://img.youtube.com/vi/nErpU8WKzIM/hqdefault.jpg",
    topics: ["Technology", "Leadership"]
  },
  {
    id: "s2-ep-51",
    title: "S2 Ep 51 - Rashmi Rao",
    description: "Leadership and professional growth insights.",
    date: "2025-09-01",
    duration: "45:00",
    season: 2,
    episode: 51,
    guest: "Rashmi Rao",
    youtubeUrl: "https://youtu.be/vBUlwRM9ZaY",
    thumbnail: "https://img.youtube.com/vi/vBUlwRM9ZaY/hqdefault.jpg",
    topics: ["Leadership", "Growth"]
  },
  {
    id: "s2-ep-50",
    title: "S2 Ep 50 - Neeraja & Sneha",
    description: "Collaborative perspectives on career development.",
    date: "2025-08-25",
    duration: "45:00",
    season: 2,
    episode: 50,
    guest: "Neeraja & Sneha",
    youtubeUrl: "https://youtu.be/TvwVxj22ntQ",
    thumbnail: "https://img.youtube.com/vi/TvwVxj22ntQ/hqdefault.jpg",
    topics: ["Career", "Development"]
  },
  {
    id: "s2-ep-49",
    title: "S2 Ep 49 - Prasad Sivalanka",
    description: "Professional insights and industry perspectives.",
    date: "2025-08-18",
    duration: "45:00",
    season: 2,
    episode: 49,
    guest: "Prasad Sivalanka",
    youtubeUrl: "https://youtu.be/RLJaI67RCX4",
    thumbnail: "https://img.youtube.com/vi/RLJaI67RCX4/hqdefault.jpg",
    topics: ["Industry", "Insights"]
  },
  {
    id: "s2-ep-48",
    title: "S2 Ep 48 - Ravishankar Iyer",
    description: "Leadership and innovation in the modern workplace.",
    date: "2025-08-11",
    duration: "45:00",
    season: 2,
    episode: 48,
    guest: "Ravishankar Iyer",
    youtubeUrl: "https://youtu.be/NvBWEqrzEqM",
    thumbnail: "https://img.youtube.com/vi/NvBWEqrzEqM/hqdefault.jpg",
    topics: ["Leadership", "Innovation"]
  },
  {
    id: "s2-ep-47",
    title: "S2 Ep 47 - Swapna",
    description: "Career growth and professional development.",
    date: "2025-08-04",
    duration: "45:00",
    season: 2,
    episode: 47,
    guest: "Swapna",
    youtubeUrl: "https://youtu.be/sw1kN1jIIck",
    thumbnail: "https://img.youtube.com/vi/sw1kN1jIIck/hqdefault.jpg",
    topics: ["Career", "Growth"]
  },
  {
    id: "s2-ep-46",
    title: "S2 Ep 46 - Bhavna Toor",
    description: "Leadership insights and professional journey.",
    date: "2025-07-28",
    duration: "45:00",
    season: 2,
    episode: 46,
    guest: "Bhavna Toor",
    youtubeUrl: "https://youtu.be/0Dj2q8TXLNc",
    thumbnail: "https://img.youtube.com/vi/0Dj2q8TXLNc/hqdefault.jpg",
    topics: ["Leadership", "Journey"]
  },
  {
    id: "s2-ep-45",
    title: "S2 Ep 45 - Pankaj Rai",
    description: "Perspectives on leadership and growth.",
    date: "2025-07-21",
    duration: "45:00",
    season: 2,
    episode: 45,
    guest: "Pankaj Rai",
    youtubeUrl: "https://youtu.be/OMR58Lad_0A",
    thumbnail: "https://img.youtube.com/vi/OMR58Lad_0A/hqdefault.jpg",
    topics: ["Leadership", "Growth"]
  },
  {
    id: "s2-ep-44",
    title: "S2 Ep 44 - Kiran Kumar",
    description: "Professional development and career insights.",
    date: "2025-07-14",
    duration: "45:00",
    season: 2,
    episode: 44,
    guest: "Kiran Kumar",
    youtubeUrl: "https://youtu.be/CE3mbUY5Iw8",
    thumbnail: "https://img.youtube.com/vi/CE3mbUY5Iw8/hqdefault.jpg",
    topics: ["Development", "Career"]
  },
  {
    id: "s2-ep-43",
    title: "S2 Ep 43 - Ajnish Rai",
    description: "Leadership and innovation perspectives.",
    date: "2025-07-07",
    duration: "45:00",
    season: 2,
    episode: 43,
    guest: "Ajnish Rai",
    youtubeUrl: "https://youtu.be/MeEEVvVSGr0",
    thumbnail: "https://img.youtube.com/vi/MeEEVvVSGr0/hqdefault.jpg",
    topics: ["Leadership", "Innovation"]
  },
  {
    id: "s2-ep-42",
    title: "S2 Ep 42 - Sai Sulakshana Badri",
    description: "Career growth and professional insights.",
    date: "2025-06-30",
    duration: "45:00",
    season: 2,
    episode: 42,
    guest: "Sai Sulakshana Badri",
    youtubeUrl: "https://youtu.be/yWX0pl6ApPc",
    thumbnail: "https://img.youtube.com/vi/yWX0pl6ApPc/hqdefault.jpg",
    topics: ["Career", "Growth"]
  },
  {
    id: "s2-ep-41",
    title: "S2 Ep 41 - Satya Gunampalli",
    description: "Professional development and leadership.",
    date: "2025-06-23",
    duration: "45:00",
    season: 2,
    episode: 41,
    guest: "Satya Gunampalli",
    youtubeUrl: "https://youtu.be/s2bvU_hsvl0",
    thumbnail: "https://img.youtube.com/vi/s2bvU_hsvl0/hqdefault.jpg",
    topics: ["Development", "Leadership"]
  },
  {
    id: "s2-ep-40",
    title: "S2 Ep 40 - Anil Kumar",
    description: "Industry insights and career perspectives.",
    date: "2025-06-16",
    duration: "45:00",
    season: 2,
    episode: 40,
    guest: "Anil Kumar",
    youtubeUrl: "https://youtu.be/uXot3Q-2CLU",
    thumbnail: "https://img.youtube.com/vi/uXot3Q-2CLU/hqdefault.jpg",
    topics: ["Industry", "Career"]
  },
  {
    id: "s2-ep-39",
    title: "S2 Ep 39 - Ajit Kamath",
    description: "Leadership and professional growth.",
    date: "2025-06-09",
    duration: "45:00",
    season: 2,
    episode: 39,
    guest: "Ajit Kamath",
    youtubeUrl: "https://youtu.be/wqeUmvRq5c0",
    thumbnail: "https://img.youtube.com/vi/wqeUmvRq5c0/hqdefault.jpg",
    topics: ["Leadership", "Growth"]
  },
  {
    id: "s2-ep-38",
    title: "S2 Ep 38 - Govind Kumar",
    description: "Career development and insights.",
    date: "2025-06-02",
    duration: "45:00",
    season: 2,
    episode: 38,
    guest: "Govind Kumar",
    youtubeUrl: "https://youtu.be/BzisJoE38Qg",
    thumbnail: "https://img.youtube.com/vi/BzisJoE38Qg/hqdefault.jpg",
    topics: ["Career", "Development"]
  },
  {
    id: "s2-ep-37",
    title: "S2 Ep 37 - Pavan Madduri",
    description: "Professional insights and leadership.",
    date: "2025-05-26",
    duration: "45:00",
    season: 2,
    episode: 37,
    guest: "Pavan Madduri",
    youtubeUrl: "https://youtu.be/0WPianEIPOc",
    thumbnail: "https://img.youtube.com/vi/0WPianEIPOc/hqdefault.jpg",
    topics: ["Insights", "Leadership"]
  },
  {
    id: "s2-ep-36",
    title: "S2 Ep 36 - Prashanth Kaddi",
    description: "Career growth and professional development.",
    date: "2025-05-19",
    duration: "45:00",
    season: 2,
    episode: 36,
    guest: "Prashanth Kaddi",
    youtubeUrl: "https://youtu.be/506aW9SRbHA",
    thumbnail: "https://img.youtube.com/vi/506aW9SRbHA/hqdefault.jpg",
    topics: ["Career", "Growth"]
  },
  {
    id: "s2-ep-35",
    title: "S2 Ep 35 - Nirbhay Lumde",
    description: "Leadership and innovation perspectives.",
    date: "2025-05-12",
    duration: "45:00",
    season: 2,
    episode: 35,
    guest: "Nirbhay Lumde",
    youtubeUrl: "https://youtu.be/1Iuhg5kszTQ",
    thumbnail: "https://img.youtube.com/vi/1Iuhg5kszTQ/hqdefault.jpg",
    topics: ["Leadership", "Innovation"]
  },
  {
    id: "s2-ep-34",
    title: "S2 Ep 34 - Rishu Srivastava",
    description: "Professional development and career insights.",
    date: "2025-05-05",
    duration: "45:00",
    season: 2,
    episode: 34,
    guest: "Rishu Srivastava",
    youtubeUrl: "https://youtu.be/orKLP5D8YPY",
    thumbnail: "https://img.youtube.com/vi/orKLP5D8YPY/hqdefault.jpg",
    topics: ["Development", "Career"]
  },
  {
    id: "s2-ep-33",
    title: "S2 Ep 33 - Kumuthini",
    description: "Career growth and leadership.",
    date: "2025-04-28",
    duration: "45:00",
    season: 2,
    episode: 33,
    guest: "Kumuthini",
    youtubeUrl: "https://youtu.be/OXCmZumvU0k",
    thumbnail: "https://img.youtube.com/vi/OXCmZumvU0k/hqdefault.jpg",
    topics: ["Career", "Leadership"]
  },
  {
    id: "s2-ep-32",
    title: "S2 Ep 32 - Saraswati Ramachandra",
    description: "Professional insights and growth.",
    date: "2025-04-21",
    duration: "45:00",
    season: 2,
    episode: 32,
    guest: "Saraswati Ramachandra",
    youtubeUrl: "https://youtu.be/J78yxD99jac",
    thumbnail: "https://img.youtube.com/vi/J78yxD99jac/hqdefault.jpg",
    topics: ["Insights", "Growth"]
  },
  {
    id: "s2-ep-31",
    title: "S2 Ep 31 - Himanshu Katiyar",
    description: "Leadership and career development.",
    date: "2025-04-14",
    duration: "45:00",
    season: 2,
    episode: 31,
    guest: "Himanshu Katiyar",
    youtubeUrl: "https://youtu.be/5Jty0UXnBX4",
    thumbnail: "https://img.youtube.com/vi/5Jty0UXnBX4/hqdefault.jpg",
    topics: ["Leadership", "Development"]
  },
  {
    id: "s2-ep-30",
    title: "S2 Ep 30 - Pramod Chandrasekhar",
    description: "Professional growth and industry insights.",
    date: "2025-04-07",
    duration: "45:00",
    season: 2,
    episode: 30,
    guest: "Pramod Chandrasekhar",
    youtubeUrl: "https://youtu.be/HPujJx_DHRY",
    thumbnail: "https://img.youtube.com/vi/HPujJx_DHRY/hqdefault.jpg",
    topics: ["Growth", "Industry"]
  },
  {
    id: "s2-ep-29",
    title: "S2 Ep 29 - Deepak Mohan",
    description: "Career insights and leadership.",
    date: "2025-03-31",
    duration: "45:00",
    season: 2,
    episode: 29,
    guest: "Deepak Mohan",
    youtubeUrl: "https://youtu.be/-pUhfaTQFrs",
    thumbnail: "https://img.youtube.com/vi/-pUhfaTQFrs/hqdefault.jpg",
    topics: ["Career", "Leadership"]
  },
  {
    id: "s2-ep-28",
    title: "S2 Ep 28 - Sai Sravan Cherukuri",
    description: "Professional development and growth.",
    date: "2025-03-24",
    duration: "45:00",
    season: 2,
    episode: 28,
    guest: "Sai Sravan Cherukuri",
    youtubeUrl: "https://youtu.be/O7_ylMvrtXY",
    thumbnail: "https://img.youtube.com/vi/O7_ylMvrtXY/hqdefault.jpg",
    topics: ["Development", "Growth"]
  },
  {
    id: "s2-ep-27",
    title: "S2 Ep 27 - Rahul Agarwal",
    description: "Leadership and innovation.",
    date: "2025-03-17",
    duration: "45:00",
    season: 2,
    episode: 27,
    guest: "Rahul Agarwal",
    youtubeUrl: "https://youtu.be/PM5Ein8ehEY",
    thumbnail: "https://img.youtube.com/vi/PM5Ein8ehEY/hqdefault.jpg",
    topics: ["Leadership", "Innovation"]
  },
  {
    id: "s2-ep-26",
    title: "S2 Ep 26 - BVS Prathap",
    description: "Career growth and professional insights.",
    date: "2025-03-10",
    duration: "45:00",
    season: 2,
    episode: 26,
    guest: "BVS Prathap",
    youtubeUrl: "https://youtu.be/ICrBMwYiT9k",
    thumbnail: "https://img.youtube.com/vi/ICrBMwYiT9k/hqdefault.jpg",
    topics: ["Career", "Growth"]
  },
  {
    id: "s2-ep-25",
    title: "S2 Ep 25 - Pankaj Rai",
    description: "Leadership perspectives and growth.",
    date: "2025-03-03",
    duration: "45:00",
    season: 2,
    episode: 25,
    guest: "Pankaj Rai",
    youtubeUrl: "https://youtu.be/I8FVZo16z84",
    thumbnail: "https://img.youtube.com/vi/I8FVZo16z84/hqdefault.jpg",
    topics: ["Leadership", "Growth"]
  },
  {
    id: "s2-ep-24",
    title: "S2 Ep 24 - Swetha Reddy",
    description: "Professional development and career.",
    date: "2025-02-24",
    duration: "45:00",
    season: 2,
    episode: 24,
    guest: "Swetha Reddy",
    youtubeUrl: "https://youtu.be/G42DJKDD4UY",
    thumbnail: "https://img.youtube.com/vi/G42DJKDD4UY/hqdefault.jpg",
    topics: ["Development", "Career"]
  },
  {
    id: "s2-ep-23",
    title: "S2 Ep 23 - Siva Kota",
    description: "Industry insights and leadership.",
    date: "2025-02-17",
    duration: "45:00",
    season: 2,
    episode: 23,
    guest: "Siva Kota",
    youtubeUrl: "https://youtu.be/dTONIMVIgM4",
    thumbnail: "https://img.youtube.com/vi/dTONIMVIgM4/hqdefault.jpg",
    topics: ["Industry", "Leadership"]
  },
  {
    id: "s2-ep-22",
    title: "S2 Ep 22 - Pradeep Janardhanan",
    description: "Career growth and development.",
    date: "2025-02-10",
    duration: "45:00",
    season: 2,
    episode: 22,
    guest: "Pradeep Janardhanan",
    youtubeUrl: "https://youtu.be/TCDFNxkwfg4",
    thumbnail: "https://img.youtube.com/vi/TCDFNxkwfg4/hqdefault.jpg",
    topics: ["Career", "Growth"]
  },
  {
    id: "s2-ep-21",
    title: "S2 Ep 21 - Zach Cherian",
    description: "Leadership and professional insights.",
    date: "2025-02-03",
    duration: "45:00",
    season: 2,
    episode: 21,
    guest: "Zach Cherian",
    youtubeUrl: "https://youtu.be/AI3MOZcbcAA",
    thumbnail: "https://img.youtube.com/vi/AI3MOZcbcAA/hqdefault.jpg",
    topics: ["Leadership", "Insights"]
  },
  {
    id: "s2-ep-20",
    title: "S2 Ep 20 - Kaushi Biddappa",
    description: "Professional growth and career development.",
    date: "2025-01-27",
    duration: "45:00",
    season: 2,
    episode: 20,
    guest: "Kaushi Biddappa",
    youtubeUrl: "https://youtu.be/YAvyBJwpwSk",
    thumbnail: "https://img.youtube.com/vi/YAvyBJwpwSk/hqdefault.jpg",
    topics: ["Growth", "Development"]
  },
  {
    id: "s2-ep-19",
    title: "S2 Ep 19 - Abhijit Bhattacharya",
    description: "Leadership and innovation perspectives.",
    date: "2025-01-20",
    duration: "45:00",
    season: 2,
    episode: 19,
    guest: "Abhijit Bhattacharya",
    youtubeUrl: "https://youtu.be/HSi5y4KZ3p4",
    thumbnail: "https://img.youtube.com/vi/HSi5y4KZ3p4/hqdefault.jpg",
    topics: ["Leadership", "Innovation"]
  },
  {
    id: "s2-ep-18",
    title: "S2 Ep 18 - Acharya Sri Satchitananda Sai",
    description: "Wisdom and spiritual leadership.",
    date: "2025-01-13",
    duration: "45:00",
    season: 2,
    episode: 18,
    guest: "Acharya Sri Satchitananda Sai",
    youtubeUrl: "https://youtu.be/INUTxBFpzvY",
    thumbnail: "https://img.youtube.com/vi/INUTxBFpzvY/hqdefault.jpg",
    topics: ["Wisdom", "Leadership"]
  },
  // Season 1
  {
    id: "s1-ep-17",
    title: "S1 Ep 17 - Warrior (Narcotics Anonymous)",
    description: "Recovery and resilience journey.",
    date: "2024-12-30",
    duration: "45:00",
    season: 1,
    episode: 17,
    guest: "Warrior (Narcotics Anonymous)",
    youtubeUrl: "https://youtu.be/kCYYDLIeuVY",
    thumbnail: "https://img.youtube.com/vi/kCYYDLIeuVY/hqdefault.jpg",
    topics: ["Recovery", "Resilience"]
  },
  {
    id: "s1-ep-16",
    title: "S1 Ep 16 - Sachin Ghorpade IPS",
    description: "Leadership in public service.",
    date: "2024-12-23",
    duration: "45:00",
    season: 1,
    episode: 16,
    guest: "Sachin Ghorpade IPS",
    youtubeUrl: "https://youtu.be/sBm-GsTquIY",
    thumbnail: "https://img.youtube.com/vi/sBm-GsTquIY/hqdefault.jpg",
    topics: ["Leadership", "Public Service"]
  },
  {
    id: "s1-ep-15",
    title: "S1 Ep 15 - Dr. Lakshmi Pingali",
    description: "Healthcare and professional growth.",
    date: "2024-12-16",
    duration: "45:00",
    season: 1,
    episode: 15,
    guest: "Dr. Lakshmi Pingali",
    youtubeUrl: "https://youtu.be/DfgHtihitBU",
    thumbnail: "https://img.youtube.com/vi/DfgHtihitBU/hqdefault.jpg",
    topics: ["Healthcare", "Growth"]
  },
  {
    id: "s1-ep-14",
    title: "S1 Ep 14 - Aarti Kaushal",
    description: "Career development and leadership.",
    date: "2024-12-09",
    duration: "45:00",
    season: 1,
    episode: 14,
    guest: "Aarti Kaushal",
    youtubeUrl: "https://youtu.be/7jhuDOT3qck",
    thumbnail: "https://img.youtube.com/vi/7jhuDOT3qck/hqdefault.jpg",
    topics: ["Career", "Leadership"]
  },
  {
    id: "s1-ep-13",
    title: "S1 Ep 13 - Gagandeep Taluja",
    description: "Professional insights and growth.",
    date: "2024-12-02",
    duration: "45:00",
    season: 1,
    episode: 13,
    guest: "Gagandeep Taluja",
    youtubeUrl: "https://youtu.be/PRJn52LoLCI",
    thumbnail: "https://img.youtube.com/vi/PRJn52LoLCI/hqdefault.jpg",
    topics: ["Insights", "Growth"]
  },
  {
    id: "s1-ep-12",
    title: "S1 Ep 12 - Dr. Lalith Sanagavarapu",
    description: "Academic and professional journey.",
    date: "2024-11-25",
    duration: "45:00",
    season: 1,
    episode: 12,
    guest: "Dr. Lalith Sanagavarapu",
    youtubeUrl: "https://youtu.be/Ep56OLHvVoE",
    thumbnail: "https://img.youtube.com/vi/Ep56OLHvVoE/hqdefault.jpg",
    topics: ["Academic", "Journey"]
  },
  {
    id: "s1-ep-11",
    title: "S1 Ep 11 - Sanjay Devudu",
    description: "Industry insights and leadership.",
    date: "2024-11-18",
    duration: "45:00",
    season: 1,
    episode: 11,
    guest: "Sanjay Devudu",
    youtubeUrl: "https://youtu.be/Bqo-3IDdMXw",
    thumbnail: "https://img.youtube.com/vi/Bqo-3IDdMXw/hqdefault.jpg",
    topics: ["Industry", "Leadership"]
  },
  {
    id: "s1-ep-10",
    title: "S1 Ep 10 - Amit Anand",
    description: "Career growth and development.",
    date: "2024-11-11",
    duration: "45:00",
    season: 1,
    episode: 10,
    guest: "Amit Anand",
    youtubeUrl: "https://youtu.be/eT4pQGkdGdM",
    thumbnail: "https://img.youtube.com/vi/eT4pQGkdGdM/hqdefault.jpg",
    topics: ["Career", "Growth"]
  },
  {
    id: "s1-ep-09",
    title: "S1 Ep 09 - Devika Rani Karri",
    description: "Professional insights and leadership.",
    date: "2024-11-04",
    duration: "45:00",
    season: 1,
    episode: 9,
    guest: "Devika Rani Karri",
    youtubeUrl: "https://youtu.be/MpJej577Rq8",
    thumbnail: "https://img.youtube.com/vi/MpJej577Rq8/hqdefault.jpg",
    topics: ["Insights", "Leadership"]
  },
  {
    id: "s1-ep-08",
    title: "S1 Ep 08 - Shubhayu Sengupta",
    description: "HR and leadership perspectives.",
    date: "2024-10-28",
    duration: "45:00",
    season: 1,
    episode: 8,
    guest: "Shubhayu Sengupta",
    youtubeUrl: "https://youtu.be/CkpZOigKxtU",
    thumbnail: "https://img.youtube.com/vi/CkpZOigKxtU/hqdefault.jpg",
    topics: ["HR", "Leadership"]
  },
  {
    id: "s1-ep-07",
    title: "S1 Ep 07 - Pankaj Rai",
    description: "Leadership and career development.",
    date: "2024-10-21",
    duration: "45:00",
    season: 1,
    episode: 7,
    guest: "Pankaj Rai",
    youtubeUrl: "https://youtu.be/OvOtt17cPkY",
    thumbnail: "https://img.youtube.com/vi/OvOtt17cPkY/hqdefault.jpg",
    topics: ["Leadership", "Career"]
  },
  {
    id: "s1-ep-06",
    title: "S1 Ep 06 - Velan Thirugnanasambandan",
    description: "Professional growth and innovation.",
    date: "2024-10-14",
    duration: "45:00",
    season: 1,
    episode: 6,
    guest: "Velan Thirugnanasambandan",
    youtubeUrl: "https://youtu.be/Gf8FxEocDGc",
    thumbnail: "https://img.youtube.com/vi/Gf8FxEocDGc/hqdefault.jpg",
    topics: ["Growth", "Innovation"]
  },
  {
    id: "s1-ep-05",
    title: "S1 Ep 05 - Nigel Hughes",
    description: "Industry insights and leadership.",
    date: "2024-10-07",
    duration: "45:00",
    season: 1,
    episode: 5,
    guest: "Nigel Hughes",
    youtubeUrl: "https://youtu.be/m3GzqN0ToFc",
    thumbnail: "https://img.youtube.com/vi/m3GzqN0ToFc/hqdefault.jpg",
    topics: ["Industry", "Leadership"]
  },
  {
    id: "s1-ep-04",
    title: "S1 Ep 04 - Poonam Gupta Khan",
    description: "Career development and growth.",
    date: "2024-09-30",
    duration: "45:00",
    season: 1,
    episode: 4,
    guest: "Poonam Gupta Khan",
    youtubeUrl: "https://youtu.be/YRG1Dq-s-pE",
    thumbnail: "https://img.youtube.com/vi/YRG1Dq-s-pE/hqdefault.jpg",
    topics: ["Career", "Development"]
  },
  {
    id: "s1-ep-03",
    title: "S1 Ep 03 - Pramod Chandrasekhar",
    description: "Leadership and professional insights.",
    date: "2024-09-23",
    duration: "45:00",
    season: 1,
    episode: 3,
    guest: "Pramod Chandrasekhar",
    youtubeUrl: "https://youtu.be/xUUk6T-ccdQ",
    thumbnail: "https://img.youtube.com/vi/xUUk6T-ccdQ/hqdefault.jpg",
    topics: ["Leadership", "Insights"]
  },
  {
    id: "s1-ep-02",
    title: "S1 Ep 02 - Suresh Neelakantan",
    description: "Industry perspectives and growth.",
    date: "2024-09-16",
    duration: "45:00",
    season: 1,
    episode: 2,
    guest: "Suresh Neelakantan",
    youtubeUrl: "https://youtu.be/DaL4-sBUd6Y",
    thumbnail: "https://img.youtube.com/vi/DaL4-sBUd6Y/hqdefault.jpg",
    topics: ["Industry", "Growth"]
  },
  {
    id: "s1-ep-01",
    title: "S1 Ep 01 - Praveen Pantula",
    description: "The journey begins - Leadership and career insights.",
    date: "2024-09-09",
    duration: "45:00",
    season: 1,
    episode: 1,
    guest: "Praveen Pantula",
    youtubeUrl: "https://youtu.be/lm2aP5rrzVY",
    thumbnail: "https://img.youtube.com/vi/lm2aP5rrzVY/hqdefault.jpg",
    topics: ["Leadership", "Career"]
  }
];

// Testimonials
export const testimonials = [
  {
    id: 1,
    name: "Kiran Rasisomayajula",
    role: "Senior Risk, Data & Analytics Leader",
    avatar: "KK",
    quote: "Wonderful topic for discussion and quite a coup to get such widely experienced panel.",
    outcome: "Quality Discussions"
  },
  {
    id: 2,
    name: "Shiv Kumar Salvase",
    role: "Business Operation Specialist",
    avatar: "SK",
    quote: "100% True: Financial literacy must begin early, especially for children and youth... Thank you Ravi for the post...",
    outcome: "Practical Wisdom"
  }
];

// Host bio
export const hostBio = {
  name: "Ravi Kanth Jagarlapudi",
  title: "Host & Creator",
  image: "https://customer-assets.emergentagent.com/job_mml-podcasts/artifacts/1dyvi8l9_Ravi.jpg",
  bio: "Ravi is a passionate advocate for lifelong learning and intentional living. With over two decades of experience in learning & development, he brings a unique perspective to conversations about growth, leadership, and the science of becoming better.\n\nThrough Monday Morning Learning Podcasts, Ravi creates a space where curious minds can explore evidence-based strategies for personal and professional development. His warm, conversational style makes complex topics accessible and actionable.",
  social: {
    spotify: "https://open.spotify.com/show/4Imx8vJprGKh7dqYvOx3KZ",
    twitter: "https://twitter.com/ravikanth",
    linkedin: "https://linkedin.com/in/ravikanth",
    email: "ravikanth.jagarlapudi@gmail.com"
  }
};

// Partners
export const partners = [
  {
    id: 1,
    name: "Sai Acuity",
    logo: "SA",
    description: "Strategic partner in learning and development.",
    url: "#"
  }
];

// Stats
export const stats = {
  totalEpisodes: "70+",
  listeners: "10K+",
  countries: "25+",
  rating: "4.9"
};
